import React, { useEffect, useState } from "react";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import SideBar from "./SideBar";
import { getAllCustomerOrders } from "../../adapters/dashboard/dashboardAdapater";
import { getUserInfoFromSession } from "../../adapters/session/localSessionAdapter";
import { Move } from "../../components/dashboard/Move";
import DashboardSkeleton from "../../components/skeleton/dashboard/DashboardSkeleton";
import { MoveDateModal } from "../../components/dashboard/estimate_details/MoveDateModal";
import { Alert } from "reactstrap";
import { DashboardProvider } from "../../context/dashboard/DashboardContext";
import { loadCheckoutScript } from "../../adapters/payment/payment";
import { ProgressModal } from "../../components/common/ProgressModal";
import { loadPDFMakeLib, loadFontLib } from "../../adapters/library/library";
import navigationsLinks from "../../constants/navigation_links";
import { useHistory } from "react-router";
import { ListOfGoodsModal } from "../../components/modal/dashboard/ListOfGoodsModal";

export default function Dashboard(props) {
  // TODO:
  // performance improvement
  /* - Records update design
   * - fetch perticular record by estimate id
   * - update present orders array using find by id with the required order
   * - reupdate the orders list.
   * - recompute the UI to re-render
   * - handle API error
   */

  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(null);
  const [alertStatus, setAlertStatus] = useState(null);
  const [orders, setOrders] = useState(null);
  const [moveDateInfo, setMoveDateInfo] = useState(null);

  const [progressModal, setProgressModal] = useState({
    status: false,
    text: "",
  });
  const [listOfGoods, setListOfGoods] = useState(null);

  const history = useHistory();
  const refresh = async (estimateId) => {
    //update move date
    //setUpdate in Progress;
    // const body = { estimateId: "E123123123" };
    // const record = await getEstimateDataByID(body);
    const { userId } = getUserInfoFromSession();
    const data = { userId };
    if (orders !== null && orders.length > 0) {
      // let allOrders = orders;
      try {
        const res = await getAllCustomerOrders(data);
        if (res.status === 200) {
          setOrders(res.data.Customer_Estimate_Flow);
        }
      } catch (e) {
        console.error("An Error Occurred", e);
      }
    }
    return;
  };
  const closeProgressModal = () => {
    setProgressModal({ status: false, text: "" });
  };

  const loadData = async () => {
    setIsLoading(true);
    const { userId } = getUserInfoFromSession();
    const load = await loadCheckoutScript();
    const loadPDFmake = await loadPDFMakeLib();
    const loadPDFfont = await loadFontLib();
    const data = { userId };
    try {
      const res = await getAllCustomerOrders(data);
      if (
        res.status === 200 &&
        load === true &&
        loadPDFmake === true &&
        loadPDFfont === true
      ) {
        if (res.data.Customer_Estimate_Flow !== undefined) {
          setOrders(res.data.Customer_Estimate_Flow);
        } else {
          setOrders([]);
        }
        setIsLoading(false);
      } else {
        console.error("An Error Occurred");
        setIsLoading(false);
      }
    } catch (e) {
      console.error("An Error Occurred", e);
      setIsLoading(false);
      setHasError(e);
    }
  };
  useEffect(() => {
    window.scrollTo(0,0);
    loadData();
  }, []);
  
  useEffect(() => {
    var timer = null;
    if (alertStatus === null) {
      clearInterval(timer);
    }
    if (alertStatus !== null) {
      let i = 1;
      timer = setInterval(function () {
        if (i > 5) {
          setAlertStatus(null);
          clearInterval(timer);
        }
        i++;
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [alertStatus]);

  const JSX = (
    <>
      <Header />
      <DashboardProvider
        value={{
          updateStatus: setAlertStatus,
          refresh: refresh,
        }}
      >
        <main className="dashbord-main-container">
          <div className="container-fluid mt-4">
            <div className="row main-header align-items-start">
              <SideBar />
              <div className="col-sm-12 col-md-12 col-lg-10">
                <div className="dashboard-header">
                  <h3 className="mb-3 dashboard-heading-title">My Moves</h3>
                  <div className="alert-container">
                    <Alert
                      color={alertStatus !== null ? alertStatus.color : ""}
                      isOpen={alertStatus !== null ? true : false}
                      toggle={() => {
                        setAlertStatus(null);
                      }}
                    >
                      {alertStatus !== null && alertStatus.message}
                    </Alert>
                  </div>
                </div>

                {hasError !== null && <> An Error Occurred </>}
                {isLoading === true && <DashboardSkeleton />}
                {orders !== null &&
                  isLoading === false &&
                  orders.map((estimate) => {
                    return (
                      <Move
                        data={estimate}
                        key={estimate.estimate_id}
                        setMoveDateInfo={setMoveDateInfo}
                        setProgressModal={setProgressModal}
                        setListOfGoods={setListOfGoods}
                      />
                    );
                  })}
                {orders !== null && orders.length === 0 && (
                  <div className="text-center">
                    <h6>You have not made any estimates.</h6>
                    <button
                      className="btn btn-sm"
                      onClick={() =>
                        history.push(navigationsLinks.move_details_page)
                      }
                    >
                      Make An Estimate Now.
                    </button>
                  </div>
                )}
                <div>
                  <MoveDateModal
                    toggle={() => {
                      setMoveDateInfo(null);
                      refresh();
                    }}
                    data={moveDateInfo}
                    isOpen={moveDateInfo !== null ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
          <ProgressModal
            isOpen={progressModal.status}
            text={progressModal.text}
            toggle={closeProgressModal}
          />
          {listOfGoods !== null && (
            <ListOfGoodsModal
              isOpen={listOfGoods.status}
              estimateId={listOfGoods.estimateId}
              toggle={() => {
                setListOfGoods(null);
              }}
            />
          )}
        </main>
      </DashboardProvider>

      <Footer />
    </>
  );
  return JSX;
}
